import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Head from 'components/basics/head';
import MktAnnouncement from 'components/mkt/mkt-announcement';
import MktSubscription from 'components/mkt/mkt-subscription';
import MktNav from 'components/navs/mkt-nav';
import MktHero from 'components/mkt/mkt-hero';
import MktConsumerPrefooter from 'components/mkt/mkt-consumer-prefooter';
import MktFooter from 'components/mkt/mkt-footer';
import CookieBanner from 'components/misc/cookie-banner';
import MktColumn from 'components/mkt/mkt-column';
import MktCollapse from 'components/mkt/mkt-collapse';
import MktTestimonial from 'components/mkt/mkt-testimonial';
import MktFeaturedProviders from 'components/mkt/mkt-featured-providers';
import FAWrapper from 'components/vendors/fa-wrapper';
import { HiwTime, HiwServices, HiwTravel } from 'utils/assets/how-it-works';
import { Wedding, Work, Shopping, Celebration, Party, NightOut, Bridesmaids } from 'utils/assets/images';
import { HairBrush, CurlingIron, HairDryer, FlatIron, SprayBottle, Makeup } from 'utils/assets/icons';
import { Container, Row, Col, Carousel, CarouselItem } from 'reactstrap';
import GetAppBanner from 'components/misc/get-app-banner';
import { StateBanner1, StateBanner2, StateBanner3 } from 'utils/assets/branding';
import { Marketreviews } from 'utils/reviews';

const MktIndexRoute = (props) => {
  const { history } = props;
  const [activeIndex, setActiveIndex] = useState(0)
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === Marketreviews.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === 0 ? Marketreviews.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const slides = Marketreviews.map((item, index) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.desktop_src}
      >
        <h4>"{item?.message}"</h4>
        <h6>-{item?.name}</h6>
      </CarouselItem>
    );
  });

  // Render
  return (
    <div className='route'>
      <Head title='Blush - On-Demand Beauty' />
      <div>
      </div>
      <GetAppBanner />
      <MktAnnouncement />
      <MktSubscription />
      <CookieBanner />
      <MktNav />
      <MktHero className='' />
      {/* <MktPartners /> */}
      <main className='mkt-main'>

        <section className='mkt-section white-bg'>
          <div className='mkt-section-title'>
            <Container>
              <h2>Servicing Areas</h2>
              <hr />
              <Link to='/book'>
                <img src={StateBanner2} alt='Colorado' style={{ height: 'auto', width: '100%', cursor: 'pointer' }} />
              </Link>
              <div style={{
                marginTop: '20px'
              }}></div>
              <Link to='/book'>
                <img src={StateBanner1} alt='Arizona' style={{ height: 'auto', width: '100%', cursor: 'pointer' }} />
              </Link>
              <div style={{
                marginTop: '20px'
              }}></div>
              <Link to='/book'>
                <img src={StateBanner3} alt='Texas' style={{ height: 'auto', width: '100%', cursor: 'pointer' }} />
              </Link>
            </Container>
          </div>
        </section>
        <section className='mkt-section white-bg'>
          <div className='mkt-section-title'>
            <Container>
              <h2>How it Works</h2>
              <hr />
            </Container>
          </div>
          <div className='mkt-section-body sm flex'>
            <Container>
              <Row>
                <Col md='4'>
                  <MktColumn
                    type='hiw'
                    img={HiwTime}
                    title='Tell Us When And Where'
                    msg="Onsite Hair and Makeup in your Home, Office, Hotel...We will meet you almost anywhere! Simply select a day and a time that works for you and we're on our way."
                    className='animated fadeInUp'
                  />
                </Col>
                <Col md='4'>
                  <MktColumn
                    type='hiw'
                    img={HiwServices}
                    title='Choose Your Services'
                    msg='Blowouts, curls, braids, special occasion hair and makeup application.'
                    className='animated fadeInUp delay-200ms'
                  />
                </Col>
                <Col md='4'>
                  <MktColumn
                    type='hiw'
                    img={HiwTravel}
                    title="Now Relax, We Are On Our Way"
                    msg='Get ready to feel beautiful.'
                    className='animated fadeInUp delay-400ms'
                  />
                </Col>
              </Row>
              <Link to='/book' className='btn btn-primary btn-md animated fadeInLeft delay-400ms'>Book Now<FAWrapper icon={'chevron-right'} className='sm ml-2' /></Link>
            </Container>
          </div>
        </section>
        <MktFeaturedProviders />
        <section className='mkt-section md '>
          <div className='mkt-section-title'>
            <Container>
              <h2>#loveletters</h2>
              <hr />
            </Container>
          </div>
          <div className='mkt-section-body md flex mkt-hero-review'>
            <Container>
              <Row className='mkt-row-container'>
                <Col md="9">
                  <Carousel
                    activeIndex={activeIndex}
                    next={next}
                    previous={previous}
                    pause={false}
                    interval={5000}
                    ride="carousel"
                  >
                    {slides}
                  </Carousel>

                </Col>

              </Row>
              <div className='mt-4 mkt-hero-paging' >
                <button
                  disabled={activeIndex === 0}
                  className="carousel-control-custom review right"
                  onClick={previous}
                >
                  <FAWrapper icon="chevron-left" />
                </button>
                <button
                  disabled={activeIndex === Marketreviews?.length - 1}
                  className="carousel-control-custom review left"
                  onClick={next}
                >
                  <FAWrapper icon="chevron-right" />
                </button>

              </div>
            </Container>
          </div>
        </section>
        <section className='mkt-section'>
          <div className='mkt-section-title'>
            <Container>
              <h2>Frequently Asked Questions</h2>
              <hr />
            </Container>
          </div>
          <div className='mkt-section-body lg flex-top'>
            <Container>

              <MktCollapse isOpen={false} icon='question-mark' title='How it works' className='animated fadeInUp'>
                <h6>
                  From day time glam to wedding glam, our Blush Hair and Makeup Artists have you covered!
                  Choose your date, time and onsite hair and makeup location and let our Pros take care of the rest!
                  You do not need to provide makeup or hair products.
                </h6>

              </MktCollapse>

              <MktCollapse isOpen={false} icon='question-mark' title='How do I prepare for my appointment?' className='animated fadeInUp delay-100ms'>
                <h6>
                  In order for our Blush Professionals to provide the ultimate experience, we ask that you have an area prepared for their arrival. The spot you choose will need a chair, outlet, and a surface area.
                </h6>
                <h6><b>Makeup:</b> Please have your face makeup free and cleansed. Having a higher chair, such as a bar chair, is helpful.</h6>
                <h6><b>Haircuts:</b>Have your hair wet, towel dried and clean prior to the arrival of your Blush Pro. Please have a broom or vacuum handy so the Pro can clean up after the haircut.</h6>
                <h6><b>Blowouts:</b> It is recommended you have your hair wet and clean prior to the arrival of a Blush Pro.</h6>
                <h6><b>Event Hair:</b> For best results, wash your hair the night prior (do not style with hot tools) and wear a loose fitting or button down shirt. Your hair must be 100% dry.</h6>
              </MktCollapse>

              <MktCollapse isOpen={false} icon='question-mark' title='How do I schedule a group booking?' className='animated fadeInUp delay-200ms'>
                <h6>Please visit <Link to='/special-events'>Group Bookings</Link> to submit your request and we'll get back to you within 24 hours!</h6>
              </MktCollapse>

              <MktCollapse isOpen={false} icon='question-mark' title='How does pricing work?' className='animated fadeInUp delay-300ms'>
                <h6>For pricing, please see our <Link to='/our-services'>Services</Link> page.</h6>
              </MktCollapse>

              <MktCollapse isOpen={false} icon='question-mark' title='How am I charged?' className='animated fadeInUp delay-300ms'>
                <h6>
                  Every booking requires a credit card on file. After the services are rendered, your
                  card will be charged and at that point you have the opportunity to leave a tip.
                </h6>
              </MktCollapse>

              <MktCollapse isOpen={false} icon='question-mark' title='Is there a travel fee?' className='animated fadeInUp delay-300ms'>
                <h6>
                  We do our best to provide you with a Blush Pro anywhere you are. If for some reason
                  you are out of the range for a Blush Pro, we charge a travel fee starting at $20.
                  If travel is required, on-demand service times are subject to change.
                </h6>
              </MktCollapse>

              <MktCollapse isOpen={false} icon='question-mark' title='What if I need to cancel?' className='animated fadeInUp delay-400ms'>
                <h6>
                  In your profile you have the capability to cancel your appointment.  If you cancel prior to 
                  the 24-hour period you will be refunded your service(s). If you cancel within a 24-hour period 
                  you will be charged 50% of the service(s). If you cancel within an hour of your service 
                  you will be charged 100% of the service(s). If you are canceling on a contractual booking 
                  such as Production work or a Wedding, the policy is listed in your contract.
                </h6>
              </MktCollapse>

              <MktCollapse isOpen={false} icon='question-mark' title='How do I become a Blush Pro?' className='animated fadeInUp delay-400ms'>
                <h6>Do you have a Cosmetology license? Simply visit the <Link to='/for-stylists'>For Stylists</Link> page and follow the easy steps to become a part of the Blush Pro Network!</h6>
              </MktCollapse>

            </Container>
          </div>
        </section>

        <MktConsumerPrefooter />

      </main>

      <MktFooter />
    </div>
  );
}

export default MktIndexRoute;